import { gql } from '@apollo/client';
import { SIMPLR_EXPERT_FIELDS_FRAGMENT } from '../simplrExpertFieldsFragment.gql';

export const BUSINESS_ALERT_FIELDS_FRAGMENT = gql`
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  fragment BusinessAlertFields on BusinessAlert {
    objectId: id
    createdAt
    updatedAt
    type
    content
    title
    blockType
    note
    status
    expirationDate
    startDate
    brands
    where
    scope
    simplrAccountId
    simplrAccountPtr {
      objectId: id
    }
    simplrExpertId
    simplrExpertPtr {
      ...SimplrExpertFields
    }
  }
`;
